{
  "user": {
    "navbar": {
      "manager": "Manager",
      "dashboard": "Dashboard",
      "logout": "Logout"
    },
    "sidebar": {
      "memberId": "Your Member ID:",
      "mySignups": "My Signups",
      "myWaitlists": "My Waitlists",
      "myBookings": "My Bookings",
      "createBooking": "Create Booking",
      "volunteering": "Volunteering",
      "viewVolunteerOpportunities": "View Volunteer Opportunities",
      "trackYourTime": "Track Your Time",
      "donate": "Donate",
      "donateNow": "Donate Now",
      "myDonations": "My Donations",
      "familyInfo": "Family Info",
      "invoices": "Invoices",
      "memberDirectory": "Member Directory",
      "myProfile": "My Profile",
      "general": "General",
      "notifications": "Notifications",
      "payment": "Payment",
      "myForms": "My Forms",
      "myWaivers": "My Waivers",
      "apiKeys": "API Keys",
      "support": "Support",
      "logout": "Logout",
      "toManagerDashboard": "To Manager Dashboard"
    }
  },
  "guest": {
    "navbar": {
      "volunteering": "Volunteering",
      "donate": "Donate",
      "login": "Login"
    },
    "sidebar": {
      "login": "Login",
      "memberships": "Memberships",
      "volunteering": "Volunteering",
      "donate": "Donate"
    }
  },
  "manager": {
    "sidebar": {
      "userDashboard": "User Dashboard"
    }
  }
}
